import api from '@/lib/api/axios'
import type { Contact, ListParams, PaginatedResponse } from '@/lib/api/types'

export const contactsApi = {
    list: (params?: ListParams) => {
        // Convert perPage to limit for backend compatibility
        const queryParams = params ? {
            ...params,
            limit: params.perPage || params.limit || 20,
            perPage: undefined,
        } : undefined
        // Remove undefined values
        if (queryParams) {
            Object.keys(queryParams).forEach(key => {
                if (queryParams[key as keyof typeof queryParams] === undefined) {
                    delete queryParams[key as keyof typeof queryParams]
                }
            })
        }
        return api.get<PaginatedResponse<Contact>>('/api/contacts', { params: queryParams })
    },

    get: (id: number) =>
        api.get<Contact>(`/api/contacts/${id}`),

    create: (data: Omit<Contact, 'id'>) =>
        api.post<Contact>('/api/contacts', data),

    update: (id: number, data: Partial<Omit<Contact, 'id'>>) =>
        api.put<Contact>(`/api/contacts/${id}`, data),

    delete: (id: number) =>
        api.delete(`/api/contacts/${id}`),
}
